// react
import React, { useState, useEffect, useContext } from 'react';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import RelatoriosPersonalizadosForm from './RelatoriosPersonalizados/RelatoriosPersonalizadosForm';
import { formateDate } from "beaktShared/helpers/masks";

// services
import { useGetApi, UsePostApi, UsePutApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatoriosPersonalizadosList() {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };
  const endPoint = "relatoriosPersonalizados/";
  const endPointGet = endPoint + "byfranquia/" + session.franquiaId;

  const [{ list, isLoadingList, isErrorGetList }, setListAtualiza] = useGetApi(endPointGet);

  const [showFormView, setshowFormView] = React.useState(false);
  const [item, setItem] = useState({});
  const [loadingForm, setLoadingForm] = React.useState(false);

  const handleAdd = data => {

    var verifyExists = list.filter(obj => {
      return obj.relatorioPersonalizado_Id === data.relatorioPersonalizado_Id;
    });

    if (verifyExists.length > 0) {
      setLoadingForm(true);
      UsePutApi(endPoint, data.relatorioPersonalizado_Id, data).then(result => {
        setLoadingForm(false);
        if (result.status !== 200 && result.status !== 201) {
          showNotification(result.message.message, 'danger');
          return false;
        }
        
        AtualizaLisRelatorios();
        showNotification(result.message,'success');

        return true;
      });
    }
    else {
      setLoadingForm(true);
      UsePostApi(endPoint, data).then(result => {
        setLoadingForm(false);
        if (result.status !== 200 && result.status !== 201) {
          showNotification(result.message.message, 'danger');
          return false;
        }
        
        AtualizaLisRelatorios();
        showNotification(result.message,'success');
        return true; 
      });
    }

    return false;
  }
  const AtualizaLisRelatorios = () => {
 
    UseGetApiSimple(endPointGet, 0).then(result => {
      if (result.status !== 200) {
        showNotification(result.message,'danger');  
        return false;
      }
      setLoadingForm(false);  
      handleView(true);
      setListAtualiza(result.data);
    });
  }

  const handleEdit = row => {
    setItem(row);
    handleView(false);
    return true;

  };
  const handleView = (resetItem) => {
    if (resetItem)
      setItem({});
    let show = showFormView === true ? false : true;
    setshowFormView(show);
  };

  const columnsProp = [
    {
      Header: t('label.description'),
      accessor: "nomeRelatorio"
    },
    {
      Header: t('label.ini_date'),
      accessor: "dataDe",
      Cell: (props) => {
        let custom_date = props.value ? formateDate(props.value) : "";
        return <span>{custom_date}</span>
      }
    },
    {
      Header: t('label.end_date'),
      accessor: "dataAte",
      Cell: (props) => {
        let custom_date = props.value ? formateDate(props.value) : "";
        return <span>{custom_date}</span>
      }
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        if (row.original.status)
          return "Ativo"
        else
          return "Inativo"
      },
    }]
  const columnsAcao = [
    {
      Header: t('label.actions'),
      Cell: row => (
        <div className="actions-right">
          <Button
            justIcon
            round
            simple
            color="success"
            className="edit"
            onClick={() => handleEdit(row.original)}
          >
            <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
              <Edit />
            </Tooltip>
          </Button>
          {" "}
        </div >
      ),
      sortable: false,
      filterable: false
    }
  ];

  let columns = [...columnsProp, ...columnsAcao]

  return (
    <div>

      <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification({ show: false })}
        close
      />

      {showFormView &&
        <RelatoriosPersonalizadosForm addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} />}

      {!showFormView &&
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t('register.list_custom_reports')}</h4>
              </CardHeader>
              <CardBody>
                <Button
                  color="primary"
                  className={classes.newButton}
                  onClick={() => handleView(true)}
                >
                  {t('button.new')}
                </Button>

                {/* {isErrorGetList && <div>{t('error_message.loading_error')}...</div>} */}
                <ReactTable
                  loading={isLoadingList}
                  data={list}
                  filterable
                  defaultFilterMethod={noCaseSensitive}
                  columns={columns}
                  defaultPageSize={10}
                  minRows={5}
                  showPaginationBottom={true}
                  className="-striped -highlight"
                  previousText={t('button.previous')}
                  nextText={t('button.next')}
                  loadingText={t('label.loading') + "..."}
                  noDataText={t('information_message.no_records_found') + "!"}
                  pageText={t('label.page')}
                  ofText={t('label.of')}
                  rowsText={t('label.rows')}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      }
      {/* 
      {alertDelete.componente}
      {detailModal} */}
    </div>
  );
}
